import React from 'react';
import { Text, Callout } from '@scale/scaleui-radix';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  return (
    <div className="w-1/3 flex flex-col gap-4">
      <Callout.Root color="red">
        <Callout.Text>
          <Text as="p" className="text-sm">
            Error loading menu items: {error}
          </Text>
        </Callout.Text>
      </Callout.Root>
    </div>
  );
};

export default ErrorDisplay;
